export default __webpack_public_path__ + "static/media/10.7a428d54.svg";